/**
 * Payment Detail Component
 * - Displays payment transaction information
 * - Shows payment amount, method, and status
 * - Includes transaction date and reference details
 */

import React from "react";
import { FaRegCalendarAlt, FaRegUser, FaRegFileAlt } from "react-icons/fa";
import { HiCurrencyDollar } from "react-icons/hi";
import AvatarBlock from "./Shared/AvatarBlock";
import InfoRow from "./Shared/InfoRow";
import StatusBadge from "./Shared/StatusBadge";
import SectionHeader from "./Shared/SectionHeader";

const PaymentDetail = ({ data }) => {
  const user = data.user || "NA";
  const type = data.type || "NA";
  const date = data.date || "NA";
  const amount = data.amount || "NA";
  const transactionId = data.transactionId || "NA";
  const status = data.status || "NA";

  // All info rows together
  const infoItems = [
    { icon: FaRegUser, label: `User: ${user}` },
    { icon: FaRegFileAlt, label: `Type: ${type}` },
    { icon: FaRegCalendarAlt, label: `Date: ${date}` },
    { icon: HiCurrencyDollar, label: `Amount: ${amount}` },
  ];

  // Split into two columns dynamically (left/right)
  const mid = Math.ceil(infoItems.length / 2);
  const leftInfo = infoItems.slice(0, mid);
  const rightInfo = infoItems.slice(mid);

  return (
    <div className="flex flex-col gap-8 mt-6 lg:mt-10">
      {/* Header with Avatar + Status */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-items-start gap-4 lg:gap-40">
        <AvatarBlock name={user} />
        <StatusBadge status={status} />
      </div>

      {/* Transaction ID Section */}
      <div>
        <SectionHeader className="mt-2 lg:mt-6">Transaction Details</SectionHeader>
        <div className="mt-4 p-4 bg-blue-50 rounded-lg border-l-4 border-blue-500">
          <div className="text-lg font-semibold text-gray-900">
            Transaction ID: {transactionId}
          </div>
        </div>
      </div>

      {/* Info Section in Two Columns */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-8 text-gray-800 text-sm sm:text-base mt-2 pl-4 lg:ml-20">
        {/* Left Column */}
        <div className="flex flex-col gap-3">
          {leftInfo.map((item, idx) => (
            <InfoRow key={idx} icon={item.icon}>
              {item.label}
            </InfoRow>
          ))}
        </div>

        {/* Right Column */}
        <div className="flex flex-col gap-3">
          {rightInfo.map((item, idx) => (
            <InfoRow key={idx} icon={item.icon}>
              {item.label}
            </InfoRow>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentDetail;
